import React, { useState } from 'react'
import Modal from 'react-modal'
import { Button, Glyphicon } from 'react-bootstrap'

import HandleDriverModal from '../Driver/HandleDriverModal'
import useForm from '../../../hooks/useForm'

type Terminal = { _id: String, company: String, name: String, email: String, phone: String, code: String, area: String, zip: String, notes: String }

type Props = {
  isModalOpen: Boolean,
  closeModal: Function,
  removeTerminal: Function,
  updateTerminal: Function,
  terminal: Terminal,
  terminals: [Terminal],
  drivers: Array<{
    _id: String,
    email: String,
    name: String,
    phone: String,
    surname: String,
    terminal: String,
    area: String,
    driver_id: String,
    carrier: String,
    password: String,
    username: String,
  }>,
}

const translations = {
  name: 'Namn & Efternamn',
  company: 'Företag',
  email: 'Email',
  phone: 'Tel',
  area: 'Område',
  code: 'Kod',
  zip: 'Postnummer',
  notes: 'Anteckningar',
  password: 'Lösenord',
}

const getDefaultFormValues = (terminal) =>
  Object.keys(translations).reduce(
    (acc, key) => ({
      ...acc,
      [key]: terminal[key],
    }),
    {}
  )

const HandleTerminalModal = ({ isModalOpen, closeModal, terminal, terminals, drivers, updateTerminal, removeTerminal }: Props) => {
  const [activeDriver, setActiveDriver] = useState('')

  const defaultFormValues = getDefaultFormValues(terminal)

  const [formValues, onFormChange] = useForm(defaultFormValues)

  return (
    <Modal isOpen={isModalOpen} onRequestClose={closeModal}>
      <button onClick={closeModal}>Stäng</button>
      <hr />

      {Object.entries(formValues).map(([key, value]) => (
        <div key={key} className="flex" style={{ justifyContent: 'flex-start', padding: 7 }}>
          <label style={{ paddingRight: 21 }}>{`${translations[key]}:`}</label>
          <input defaultValue={terminal[key]} onChange={onFormChange} name={key} className="change-input form-control" type="text" value={value} />
        </div>
      ))}

      <Button className="save-settings-btn" style={{ width: '100%' }} type="submit" onClick={() => updateTerminal({ _id: terminal._id, ...formValues }).then(closeModal)}>
        <Glyphicon glyph="glyphicon glyphicon-pencil" /> &nbsp; Spara
      </Button>

      <Button className="smallQbuttonWarning" style={{ width: '100%' }} type="submit" onClick={() => removeTerminal(terminal._id, terminal.email, closeModal)}>
        <Glyphicon glyph="glyphicon glyphicon-remove" /> &nbsp; Ta bort åkeri
      </Button>

      <hr style={{ width: '100%', marginTop: 80 }} />

      <h4>Chaufförer</h4>
      {drivers.map((driver) => (
        <div key={driver._id}>
          <Button onClick={() => setActiveDriver(driver._id)}>{`${driver.name} ${driver.surname}`}</Button>
          <HandleDriverModal modalIsOpen={activeDriver === driver._id} closeModal={() => setActiveDriver('')} driver={driver} terminals={terminals} />
        </div>
      ))}
    </Modal>
  )
}

export default HandleTerminalModal
